<template>
  <section v-on:click="bubbleOpen = false" v-on:touchstart="bubbleOpen = false">
    <button class="backBtn" v-on:click="goBack"><span>Kembali</span></button>
    <div class="sound withBack">
      <div :class="{soundBtn: true, on: audioPlaying}" v-on:click="toggleSound"></div>
      <div class="soundLabel">
        Sound
        <span v-if="audioPlaying">On</span>
        <span v-else>Off</span>
      </div>
    </div>
    <div class="menuCnt">
      <div class="menuToggle" v-on:click.stop="openMenu = !openMenu"></div>
      <div :class="{menu: true, open: openMenu}" v-on:click.stop="doNothing">
        <div class="menuItem left">Download Brosur</div>
        <div class="menuItem right" v-on:click="openFaq">FAQ</div>
      </div>
    </div>
    <div class="lHeader">
      <div class="leafL"></div><div class="leafR"></div>
      <div class="rumputL"></div><div class="rumputL rumputL2"></div>
      <div class="rumputR"></div><div class="rumputR rumputR2"></div>
    </div>
    <div class="stages">
      <video muted controls id="video"></video>
      <div class="cameraCnt" v-on:click="openCamera">
      </div>
      <div class="tide"></div><div class="tideBg"></div>
    </div>
    <div class="bolaPantai"></div><div class="payungB"></div><div class="payungA"></div>
    <div class="tide"></div><div class="tideBg"></div>
    <div class="catch" v-if="openCatch">
      <iframe src="http://qwe.local/catch/" ref="iframe"></iframe>
    </div>
    <Main ref="main"/>
    <Faq ref="faq"/>
  </section>
</template>

<script>
import Main from '@/components/Main.vue';
import Faq from '@/components/Faq.vue';

export default {
  name: 'home',
  components: { Main, Faq },
  data() {
    return {
      y: '',
      name: '',
      titleAn: false,
      audioPlaying: false,
      bubbleOpen: true,
      bubbleAn: true,
      bubbleCnt: true,
      openMenu: false,
      openCatch: false,
      cameraStream: null,
    };
  },
  methods: {
    doNothing() {},
    add2Calendar() {
      this.$refs.add2Calendar.open();
    },
    openCamera() {
      const video = document.getElementById('video');
      const mediaSupport = 'mediaDevices' in navigator;
      if (mediaSupport) {
        navigator.mediaDevices.getUserMedia({ video: true }).then((stream) => {
          this.cameraStream = stream;
          video.srcObject = stream;
          video.play();
        }).catch((err) => {
        });
      }
    },
    openFaq() {
      this.$refs.faq.open();
    },
    goBack() {
      window.history.back();
    },
    toggleBubble() {
      if (!this.bubbleOpen) {
        this.bubbleAn = false;
        this.bubbleOpen = true;
        this.bubbleCnt = false;
        setTimeout(() => {
          this.bubbleAn = true;
        });
        setTimeout(() => {
          this.bubbleCnt = true;
        }, 200);
      } else {
        this.bubbleOpen = false;
      }
    },
    toggleSound() {},
    startGame() {
      this.openCatch = true;
    },
  },
  computed: {
  },
  mounted() {
    const d = new Date();
    this.y = d.getFullYear();
    this.name = localStorage.getItem('name');
    const token = localStorage.getItem('token');
    if (!token) {
      this.$refs.main.open((name) => {
        this.name = name;
      });
    }
    setTimeout(() => {
      this.titleAn = true;
    });
    window.addEventListener('message', (e) => {
      this.openCatch = false;
    });
  },
};
</script>

<style scoped lang="scss">
section{
  background-color: #ffc9ca;
  background-image: linear-gradient(#ffc9ca, #fdbbce);
  position: fixed;
  left: 0; top: 0; right: 0; bottom: 0;
  @media (max-width: 680px) {
    position: static;
  }
}
#video{
  width: 300px; height: 200px;
  background-color: yellow;
}
.menuCnt{
  position: fixed;
  right: 0; top: 0;
  overflow: hidden;
  height: 100px; width: 400px;
  z-index: 997;
}
.title{
  width: 440px; height: 260px;
  position: absolute;
  left: 50%; top: -260px;
  background-image: url(../assets/tentang-title.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-left: -220px;
  z-index: 91;
  transition: all .3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  &.an{
    top: -80px;
    @media (max-width: 680px) {
      top: -70px;
    }
  }
  @media (max-width: 680px) {
    width: 280px; margin-left: -140px;
  }
}
.catch{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  z-index: 9;
  iframe{
    border: none;
    position: absolute;
    left: 0; top: 0;
    width: 100%; height: 100%;
  }
}
.stages{
  position: absolute;
  top: 50%; left: 0; right: 0;
  z-index: 9;
  transform: translateY(-50%);
  flex-wrap: wrap;
  @media (max-width: 680px) {
    position: relative;
    transform: none;
    left: auto; top: auto; right: auto;
    display: block;
    transform: none;
    padding-top: 140px;
    margin: 0;
  }
  .cameraCnt{
    width: 80px; height: 80px;
    background-color: blue;
    margin: 0 auto;
  }
  .tide, .tideBg{
    display: none;
  }
  @media (max-width: 680px) {
    padding-bottom: 140px;
    overflow: hidden;
    position: relative;
    .tide, .tideBg{
      display: block;
    }
  }
}
.payungB{
  width: 300px; height: 300px;
  position: fixed;
  right: -100px; bottom: -100px;
  background-image: url(../assets/umbrela-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
  @media (max-width: 680px) {
    width: 140px; height: 140px;
    right: -60px; bottom: -60px;
  }
}
.payungA{
  width: 300px; height: 300px;
  position: fixed;
  left: -200px; top: 50%;
  margin-top: -150px;
  background-image: url(../assets/umbrela-red.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
  @media (max-width: 680px) {
    width: 140px; height: 140px;
    top: 50%; left: -100px; margin-top: -40px;
  }
}.bolaPantai{
  width: 120px; height: 120px;
  position: fixed;
  right: -60px; top: 50%;
  transform: translateY(-50%);
  margin-top: -30px;
  background-image: url(../assets/bola-pantai.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 4;
  @media (max-width: 680px) {
    width: 80px; height: 80px;
    top: 300px; right: -40px;
  }
}

.recommender{
  display: none !important;
  position: fixed;
  right: 60px; bottom: 30px;
  width: 120px; height: 120px;
  background-image: url(../assets/star-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 99;
  @media (max-width: 1169px) {
    right: 30px; bottom: 20px;
  }
  @media (max-width: 680px) {
    width: 60px; height: 60px;
    background-size: 40px auto;
    background-color: #fdd5db;
    background-color: #ffecef;
    // background-color: #f8e051;
    border-radius: 30px 3px 30px 30px;
    box-shadow: 2px 2px 10px rgba(0,0,0,.4);
    right: 16px;
  }
  .bubble{
    display: none;
    position: absolute;
    right: 20px; bottom: 100%;
    margin-bottom: 20px;
    background-color: #fdd5db;
    padding: 20px 24px;
    border-radius: 10px;
    width: 340px;
    box-shadow: 2px 2px 6px rgba(0,0,0,.3);
    @media (max-width: 1400px) {
      width: 300px;
      font-size: 14px;
    }
    @media (max-width: 680px) {
      background-color: #ffecef;
      display: none;
      right: 0; margin-bottom: 10px;
      border-radius: 15px 15px 0 15px;
      width: 260px;
      padding: 20px;
      // font-weight: normal;
      // opacity: 0;
      transition: all .2s ease;
      width: 20px; height: 20px;
      overflow: hidden;
      .bubbleContent{
        opacity: 0;
        transition: all .1s ease;
      }
      &.cnt{
        .bubbleContent{
          opacity: 1;
        }
      }
      &.open{
        display: block;
      }
      &.an{
        opacity: 1;
        transform: none;
        width: 260px; height: 150px;
      }
    }
    .bubbleContent{
      position: relative;
      z-index: 7;
      p{
        margin: 0 0 16px;
        @media (max-width: 680px) {
          margin-bottom: 10px;
        }
      }
    }
    .arrow{
      position: absolute;
      border-left: transparent 16px solid;
      border-right: transparent 16px solid;
      border-top: #fdd5db 20px solid;
      bottom: -20px; right: 30px;
      z-index: 2;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .arrow2{
      position: absolute;
      border-left: transparent 20px solid;
      border-right: transparent 20px solid;
      border-top: #000 24px solid;
      bottom: -24px; right: 26px;
      z-index: 1;
      filter: blur(4px);
      opacity: .5;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .arrow3{
      position: absolute;
      right: 20px; width: 60px; height: 20px; bottom: 0;
      background-color: #fdd5db;
      z-index: 3;
      @media (max-width: 680px) {
        display: none;
      }
    }
    .btn{
      font-size: 14px;
      box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      @media (max-width: 680px) {
        font-size: 12px;
        padding: 10px 14px 7px;
      }
    }
  }
}

.tideBg{
  background-image: url(../assets/tide-bg-fliped.png);
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  position: absolute;
  left: -200px; right: 200px; bottom: -180px;
  height: 460px;
  transform: rotate(18deg);
  z-index: 1;
  @media (max-width: 1260px) {
    transform: rotate(20deg);
  }
  @media (max-width: 1024px) {
    right: 0; height: 400px;
  }
  @media (max-width: 680px) {
    height: 200px; bottom: 0;
    display: none;
  }
}
.tide{
  background-image: url(../assets/tide-fliped.png);
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  position: absolute;
  left: -200px; right: 200px; bottom: -260px;
  height: 460px;
  transform: rotate(14deg);
  animation: tideAn 10s infinite ease;
  z-index: 3;
  @media (max-width: 1260px) {
    transform: rotate(18deg);
  }
  @media (max-width: 1024px) {
    right: 0; height: 400px;
  }
  @media (max-width: 680px) {
    height: 200px; bottom: 0;
    animation: tideAnSm 10s infinite ease;
    display: none;
  }
  @keyframes tideAn {
    0% {bottom: -240px;}
    40% {bottom: -300px;}
    60% {bottom: -300px;}
    100% {bottom: -240px;}
  }
  @keyframes tideAnSm {
    0% {bottom: -60px;}
    40% {bottom: -110px;}
    60% {bottom: -110px;}
    100% {bottom: -60px;}
  }
}

.star1{
  width: 74px; height: 74px;
  position: fixed;
  left: 260px; bottom: 180px;
  background-image: url(../assets/star-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 40px; height: 40px;
    left: 20px; bottom: 80px;
  }
}
.star2{
  width: 74px; height: 74px;
  position: fixed;
  right: 36%; bottom: 260px;
  background-image: url(../assets/star-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
  @media (max-width: 680px) {
    width: 60px; height: 60px;
    bottom: 200px; right: 40px;
  }
}
.umang{
  width: 74px; height: 74px;
  position: fixed;
  left: -74px; bottom: 120px;
  background-image: url(../assets/kepiting-orange.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: umangAn 65s infinite linear;
  z-index: 2;
  @media (max-width: 680px) {
    width: 40px; height: 40px;
    bottom: 80px;
  }
  @keyframes umangAn {
    from { left: -74px; }
    to { left: 110%; }
  }
}
.rumputL{
  width: 280px; height: 500px;
  position: fixed;
  left: 380px; top: -396px;
  background-image: url(../assets/rumput-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  @media (max-width: 1100px) and (max-height: 1100px) {
    height: 400px; top: -320px; left: 240px;
  }
  @media (max-width: 680px) {
    height: 240px;
    top: -180px; left: 60px;
    display: none;
  }
  &.rumputL2{
    background-image: url(../assets/rumput-r2.png);
    left: 600px;
    top: -420px;
  }
}
.rumputR{
  width: 280px; height: 500px;
  position: fixed;
  right: 260px; top: -396px;
  background-image: url(../assets/rumput-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  @media (max-width: 680px) {
    display: none;
  }
  &.rumputR2{
    background-image: url(../assets/rumput-l2.png);
    right: 460px;
    top: -420px;
    @media (max-width: 1600px) {
      display: none;
    }
  }
}
.lHeader{
  position: absolute;
  left: 0; right: 0; top: 0;
  overflow: hidden; height: 600px;
}
.leafL{
  width: 540px; height: 540px;
  position: fixed;
  left: -200px; top: -176px;
  background-image: url(../assets/leaf-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: l1An 10s infinite ease;
  z-index: 8;

  // Smaller leaf
  width: 480px; height: 480px;
  left: -160px; top: -160px;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    left: -140px; top: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    left: -80px; top: -80px;
  }
  @keyframes l1An {
    0% {transform: rotate(0deg);}
    10% {transform: rotate(0deg);}
    45% {transform: rotate(10deg);}
    55% {transform: rotate(10deg);}
    90% {transform: rotate(0deg);}
    100% {transform: rotate(0deg);}
  }
}
.leafR{
  width: 540px; height: 540px;
  position: fixed;
  right: -180px; top: -140px;
  background-image: url(../assets/leaf-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;

  width: 480px; height: 480px;
  right: -160px; top: -160px;
  @media (max-width: 1100px) and (max-height: 1100px) {
    width: 400px; height: 400px;
    right: -140px; top: -140px;
  }
  @media (max-width: 680px) {
    width: 240px; height: 240px;
    right: -80px; top: -80px;
  }
}
@keyframes windAn {
  0% {transform: rotate(0deg);}
  10% {transform: rotate(0deg);}
  45% {transform: rotate(8deg);}
  55% {transform: rotate(8deg);}
  90% {transform: rotate(0deg);}
  100% {transform: rotate(0deg);}
}
</style>
